import React, { Component } from 'react';
import { Popover, Input, Modal, Icon, Button, Checkbox, Radio, Transfer, Select } from 'antd';
// import Row from './row';
// import Col from './col';
import SvgIcon from 'SvgIcon';
import * as  eChartCommon from '../echart/eChartCommon';
import * as  eChartProxy from '../echart/eChartProxy';
import Newformula from './newformula';
import uniqueId from 'lodash/uniqueId';
const RadioGroup = Radio.Group;
let Sortable = null;
if (process.env.__CLIENT__) Sortable = require('react-sortablejs');
export default class SumAreaSetting extends React.Component {
  constructor(props) {
    super(props);
    const { viewModel } = props;
    const { billNo } = viewModel.getParams();
    this.state = {
      billnum: billNo,
      bShowList: false,
      showCardFieldName: "",
      showCardEle: {},
      bOnlyShowSelected: true,
      inMouseField: "",
      sumConfig: {},
      newAdd: false,
      sEditDelete: false,
      editData: {},
      addFormula: false,
      showPop: false,
      copyItems: [],
      dependsValue: [],
    };
    // this.formulaLaft = [],this.readioValue = '',this.showName = '';
    this.readioValue = '', this.showName = '';
    this.controlModal = false;//控制点击确定框时出发popover的显示隐藏
  }

  componentDidMount() { }

  render() {
    let self = this;
    let type = self.state.bShowList ? "up" : "down";
    let listContent2 = this.getListContent();
    let className = this.props.className;
    let conditionPop = (
      <div style={{ float: 'left' }} className={className}>
        <Popover
          placement="bottom"
          overlayClassName="sumareasetting_list"
          // overlayStyle={{ width: "600px" }}
          content={listContent2}
          trigger={"click"}
          visible={self.state.bShowList && _.isEmpty(listContent2) == false}
          // visible={self.state.showPop}
          onVisibleChange={(visible) => self.onVisibleChange(visible, self)}
        >
          <Button onClick={() => self.ShowList()} type={type}  >
            <SvgIcon type="huizongshezhi" className={"icon-huizongshezhi"} />
            <span>{self.props.name ? self.props.name : "汇总设置"}</span>
          </Button>
        </Popover>
      </div>
    );
    return conditionPop;
  }
  onVisibleChange(visible, self) {
    if (self.controlModal) return;
    if (visible == false && self.state.showCardFieldName == "") {
      self.setState({ bShowList: false, showCardFieldName: "", bOnlyShowSelected: true });
    }
  }
  ShowList = () => {
    let self = this;
    let bShowList = !self.state.bShowList;
    if (bShowList == true) {
      // this.formulaLaft = []
      self.setState({ bShowList, sumConfig: {}, showCardFieldName: "", bOnlyShowSelected: true, showPop: true });
      self.getConfig();
    }
    else {
      // self.setState({ bShowList, showCardFieldName: "", bOnlyShowSelected: true });
    }
  }
  sortClick(type, fieldname) {
    let sumConfig = this.state.sumConfig;
    let curIndex = _.findIndex(sumConfig.items, function (o) { return o.fieldname == fieldname })
    let index2 = -1;
    if (type == "up") {
      index2 = _.findLastIndex(
        sumConfig.items,
        function (o, index) {
          return o.selected == 1 && index < curIndex;
        });
    }
    else {
      index2 = _.findIndex(sumConfig.items,
        function (o, index) {
          return o.selected == 1 && index > curIndex;
        });
    }
    if (index2 >= 0 && index2 < sumConfig.items.length) {
      let tmp = sumConfig.items[curIndex];
      sumConfig.items[curIndex] = sumConfig.items[index2];
      sumConfig.items[index2] = tmp;
    }
    this.setState({ sumConfig });
  }
  ShowCard(ele, index) {
    this.readioValue = '';
    this.showName = '';
    let showCardEle = _.cloneDeep(ele);
    this.setState({ showCardEle: showCardEle, showCardFieldName: ele.fieldname });
  }
  onMouseEnter(bFlag, ele, index) {
    if (bFlag) {
      ele.groupType == 4 ? this.setState({ inMouseField: ele.fieldname, sEditDelete: true }) : this.setState({ inMouseField: ele.fieldname, sEditDelete: false })
    }
    else {
      this.setState({ inMouseField: "", sEditDelete: false });
    }
  }
  onChecked(e, element, index) {
    // this.formulaLaft = [];
    let addLength = 0;
    let checked = e.target.checked;
    let sumConfig = this.state.sumConfig;
    let sumConfigItems = [], dependItems = [], dependsValue = [];
    if (element.columnDefine) {
      element.columnDefine = JSON.parse(element.columnDefine)
      element.columnDefine.bShowIt = checked ? "true" : "false";
      sumConfig.items[index].columnDefine = JSON.stringify(element.columnDefine)
    }
    addLength = _.filter(sumConfig.items, function (element) {
      if (element.columnDefine) {
        let columnDefine = typeof (element.columnDefine) == 'string' ? JSON.parse(element.columnDefine) : element.columnDefine
        return columnDefine.bShowIt == "false" && element.selected == 1
      }
    }).length
    if (!checked) {
      if (element.depends) {
        let splitDepends = element.depends.split(',')
        dependItems = dependItems.concat(splitDepends)
        dependItems = dependItems.filter(function (element, index, self) {
          return self.indexOf(element) === index;
        })
        dependsValue = this.getDepends(dependItems, dependsValue, sumConfig.items).concat(dependItems)
        dependsValue = dependsValue.filter(function (element, index, self) {
          return self.indexOf(element) === index;
        })
        if(dependsValue.length > 0){
          sumConfig.items.forEach((ele) => {
            if (ele.columnDefine) {
              ele.columnDefine = JSON.parse(ele.columnDefine)
            }
            if (ele.selected && ele.columnDefine.bShowIt == "false") {
              let _index = _.findIndex(dependsValue, (obj) => {
                return obj == ele.fieldname
              })
              if (_index > -1) {
                Object.assign(ele.columnDefine,{ "bShowIt": "true" });
                ele.selected = 0;
                ele.columnDefine = JSON.stringify(ele.columnDefine);
                sumConfigItems.push(ele)
              }
              else{
                if (ele.columnDefine && typeof (ele.columnDefine) != 'string') {
                  ele.columnDefine = JSON.stringify(ele.columnDefine)
                }
                sumConfigItems.push(ele)
              }
            }
            else {
              if (ele.columnDefine && typeof (ele.columnDefine) != 'string') {
                ele.columnDefine = JSON.stringify(ele.columnDefine)
              }
              sumConfigItems.push(ele)
            }
          })
          sumConfig.items = sumConfigItems;
        }
      }

      let formuladefind = sumConfig.items.filter(v => v.selected && v.groupType == 4)
      if (element.groupType == 4) {
        sumConfig.items[index].selected = 0
        this.setState({ sumConfig });
      }
      else {
        if (formuladefind && formuladefind.length > 0) {
          formuladefind.forEach((ele) => {
            let newEle = JSON.parse(ele.columnDefine).expression
            let isChecked = newEle && newEle.indexOf(`[${element.fieldname}]`) > -1 ? true : false;
            if (element.columnDefine) {
              element.columnDefine = JSON.parse(element.columnDefine)
              element.columnDefine.bShowIt = isChecked && element.fieldname ? "true" : "false";
              sumConfig.items[index].columnDefine = JSON.stringify(element.columnDefine)
            }
            if (isChecked && element.fieldname) {
              cb.utils.alert("此汇总项已被" + ele.caption + "公式引用不可取消")
              element.selected = 1;

              // this.setState
            }
            else {
              element.selected = 0
              // sumConfig.items[index].selected = 0;
              // this.setState({sumConfig})

            }
          })
          // let _index = _.findIndex(sumConfig.items, (obj) => {
          //   return obj.fieldname == element.fieldname
          // })
          // if (_index > -1) {
          //   sumConfig.items[_index].selected = element.selected;
          //   this.setState({ sumConfig })
          // }
          sumConfig.items[index].selected = element.selected;
          this.setState({ sumConfig })
        }
        else {
          sumConfig.items[index].selected = 0;
          this.setState({ sumConfig })
        }

      }
    }
    else {
      // if(element.columnDefine){
      //   element.columnDefine = typeof(element.columnDefine)=='string' ? JSON.parse(element.columnDefine) : element.columnDefine
      //   element.columnDefine.bShowIt = "true";
      //   sumConfig.items[index].columnDefine = typeof(element.columnDefine)=='string' ? element.columnDefine :JSON.stringify(element.columnDefine)
      // }
      // addLength = _.filter(sumConfig.items, function (element) {
      //   if(element.columnDefine){
      //     element.columnDefine = typeof(element.columnDefine)=='string' ? JSON.parse(element.columnDefine) : element.columnDefine
      //     return element.columnDefine.bShowIt == "false"
      //   }
      //  }).length
      if (checked && _.filter(sumConfig.items, function (o) { return o.selected == 1; }).length >= (8 + addLength)) {
        cb.utils.alert("最多选择8个汇总项。");
        this.setState({ addFormula: true });
      }
      else {
        sumConfig.items[index].selected = checked ? 1 : 0;
        if (checked && _.filter(sumConfig.items, function (o) { return o.selected == 1; }).length > (7 + addLength)) {
          this.setState({ addFormula: true, sumConfig })
        }
        else {
          this.setState({ addFormula: false, sumConfig });
        }
      }
    }
  }

  setShowCaption(value, index, ele) {
    if (!value && ele.groupType == 4) {
      cb.utils.alert("公式别名不可为空")
    }
    else {
      this.showName = value;//全局变量保存别名
      document.getElementById('schildinput' + index).value = value;
    }
  }

  handleRadioChange(value, ele, index, sindex) {
    this.readioValue = value;//全局变量保存汇总值
  }

  handleCardOk(ele) {
    let self = this;
    let showCardEle = self.state.showCardEle;
    let sumConfig = this.state.sumConfig;
    if (ele.groupType == 4 && (!self.showName || !ele.showCaption)) {
      cb.utils.alert("请输入公式别名")
    }
    else {
      let tmp = _.find(sumConfig.items, function (o) { return o.fieldname == self.state.showCardFieldName });
      // tmp.value = showCardEle.value;
      // tmp.showCaption = showCardEle.showCaption;
      tmp.value = self.readioValue ? self.readioValue : tmp.value;
      tmp.showCaption = self.showName;
      self.setState({ sumConfig, showCardFieldName: "" });
    }
  }
  handleCardClear(ele) {
    if (ele.groupType == 4) {
      cb.utils.alert("公式不可清空")
    }
    else {
      let self = this;
      self.readioValue = "";
      self.showName = "";
      let sumConfig = self.state.sumConfig;
      let tmp = _.find(sumConfig.items, function (o) { return o.fieldname == self.state.showCardFieldName });
      tmp.value = null;
      tmp.showCaption = "";
      self.setState({ sumConfig, showCardFieldName: "" });
    }
  }
  handleCardCancel() {
    this.setState({ showCardFieldName: "" });
  }
  getCardContent(sindex) {
    let self = this;
    let cardContent;
    let ele = self.state.showCardEle;
    if (ele) {
      let arr = [], defaultradio = "";
      if (ele.enumArray) {
        arr = JSON.parse(ele.enumArray);
        defaultradio = ele.groupType == 4 ? "" : ele.value
        if (ele.groupType == 4) {
          arr.forEach((ele) => {
            ele.disabled = true
          })
        }
      }
      else {
        arr = [
          { "nameType": "text", "value": "汇总", "key": "sum", "disabled": false },
          { "nameType": "text", "value": "计数", "key": "count", "disabled": false },
          { "nameType": "text", "value": "平均", "key": "avg", "disabled": false },
          { "nameType": "text", "value": "最小", "key": "min", "disabled": false },
          { "nameType": "text", "value": "最大", "key": "max", "disabled": false },
          { "nameType": "text", "value": "去重计数", "key": "count_distinct", "disabled": false }
        ];
      }
      // arr.push({ "nameType": "text", "value": "无无", "key": "" }, )
      let contentArr = [];
      arr.forEach((ele, index) => {
        contentArr.push(<Radio disabled={ele.disabled} value={ele.key}>{ele.value}</Radio>)
      })
      cardContent =
        <div>
          <div className="sumareasetting_disname">
            <span>显示名称:</span>
            <Input
              id={'schildinput' + sindex}
              placeholder={ele.showCaption ? ele.showCaption : "显示名称"}
              onFocus={() => {
                document.getElementById('schildinput' + sindex).value = ele.showCaption ? ele.showCaption : "";
              }}
              onChange={(e) => self.setShowCaption(e.target.value, sindex, ele)}
            />
          </div>
          <div>
            <RadioGroup
              onChange={(e) => {
                self.handleRadioChange(e.target.value, ele)
              }}
              // value={ele.value ? ele.value : "sum"}
              defaultValue={defaultradio}>
              {contentArr}
            </RadioGroup>
          </div>
          <div className="footer-btn">
            <Button type={"primary"} onClick={() => this.handleCardOk(ele)}>确定</Button>
            <Button className="up-search" type={"primary"} onClick={() => this.handleCardClear(ele)}>清空</Button>
            <Button type={"default"} onClick={() => this.handleCardCancel()}>取消</Button>
          </div>
        </div>
    }
    return cardContent;
  }
  onCardVisibleChange(visible, self) {
    // this.formulaLaft = []
    if (visible == false) {
      self.setState({ showCardFieldName: "" });
    }
  }
  getListContent() {
    let self = this;
    if (_.isEmpty(self.state.sumConfig)) {//|| self.state.bShowList == false
      return null;
    }
    else {
      let listContent = [];
      let listContentInner = [];

      let bOnlyShowSelected = self.state.bOnlyShowSelected ? true : false;
      listContent.push(
        <div className="sumarea_list_caption">
          <span className="sumareaset-left">汇总设置</span>
          <Checkbox
            title={"只显示已选"}
            checked={bOnlyShowSelected}
            onChange={(e) => { self.setState({ bOnlyShowSelected: !bOnlyShowSelected }) }}>
            {"只显示已选"}
          </Checkbox>
        </div>
      );
      let cardContent;//= this.getCardContent()
      let items = self.state.sumConfig.items
      // let methordObj = { "sum": "汇总", "count": "计数", "avg": "平均", "min": "最小", "max": "最大", "count_distinct": "去重计数", }
      items.forEach(function (ele, index) {
        let item;
        let selected = ele.selected == 1 ? 1 : 0;
        if (ele.columnDefine) {
          ele.columnDefine = typeof (ele.columnDefine) == 'string' ? JSON.parse(ele.columnDefine) : ele.columnDefine
          let bShowIt = ele.columnDefine.bShowIt;
          if (bShowIt == "false") {
            selected = 0;
          }
          ele.columnDefine = typeof (ele.columnDefine) == 'string' ? ele.columnDefine : JSON.stringify(ele.columnDefine)
        }
        // this.formulaLaft = ele.selected == 1? this.formulaLaft.push(ele) :this.formulaLaft
        if (ele.groupType == 4) {
          ele.value = "";
        }
        cardContent = null;
        if (self.state.showCardEle.fieldname == ele.fieldname) {
          cardContent = self.getCardContent(index);
        }
        let showCurrent = (self.state.showCardFieldName == ele.fieldname ? true : false);
        if (selected || bOnlyShowSelected == false) {
          let updown = ele.groupType == 4 ? <span className="sumarea_formula">
            <div className="edit_formula" onClick={() => this.editFormula(ele)}><Icon type="edit-disabled" /></div>
            <div className="delete_formula" onClick={() => this.deleteFormula(ele.fieldname)}><Icon type="delete-disabled" /></div>
          </span>
            :
            <span></span>
          item =
            <div className="sumarea_list_item"
              key={uniqueId()} data-id={index}
            >
              <Icon type="tuodong" />
              <div className="sumarea_list_item_1" >

                <Checkbox title={ele.caption} checked={(selected == 1) ? true : false} onChange={(e) => self.onChecked(e, ele, index)}>
                  {ele.caption}
                </Checkbox>
                <div className="sumarea_showcaption_all">
                  {ele.showCaption ? <div><span className="sumarea_showcaption_1">(</span> <span className="sumarea_showcaption_2"> {ele.showCaption}</span><span className="sumarea_showcaption_3">)</span> </div> : ""}
                </div>
              </div>
              <Popover
                placement="bottom"
                overlayClassName="sumareasetting_card"
                // overlayStyle={{ width: "600px" }}
                content={cardContent}
                trigger={"click"}
                visible={showCurrent}
                arrowPointAtCenter
                onVisibleChange={(visible) => self.onCardVisibleChange(visible, self)}
              // getPopupContainer={(triggerNode) => {return triggerNode.parentElement}}
              >
                <div className="summary_select_all">
                  <Button
                    className={"sumarea_list_itemarrow_" + (showCurrent ? "1" : "0")}
                    // disabled={!selected}
                    onClick={() => self.ShowCard(ele, index)}
                  >
                    {/* {methordObj[ele.value ? ele.value : "sum"]} */}
                    {self.getEleText(ele)}
                    <Icon
                      className="arrow_direction"
                      type={showCurrent ? "up" : "down"}
                    />
                  </Button>
                </div>
              </Popover>
              {updown}
            </div>;
          listContentInner.push(item);
        }
      }, this);
      //拖拽组件
      listContent.push(<div className="sumarea_list_items">
        <Sortable
          tag="div"
          options={{
            group: {
              name: 'shared',
              pull: false,
              put: false
            },
            axis: "xy"
          }}
          onChange={(evl) => {
            this.dragOrder(evl)
          }}
        >
          {listContentInner}
        </Sortable>
      </div>);
      // let AddFormula = this.state.newAdd?<Newformula closeAdd={this.closeAdd} model={this.props.viewModel} formulaData={this.formulaLaft} sumConfig={this.state.sumConfig} editData={this.state.editData}></Newformula>:""
      let AddFormula = this.state.newAdd ? <Newformula closeAdd={this.closeAdd} model={this.props.viewModel} sumConfig={this.state.sumConfig} editData={this.state.editData}></Newformula> : ""
      return (
        <div>
          <div>{listContent}</div>
          <div className="footer-btn">
            <Button type={"primary"} onClick={() => this.handleOk()}>确定</Button>
            <Button className="up-search" disabled={this.state.addFormula} type={"default"} onClick={() => this.handleAdd()}>新增公式</Button>
            <Button type={"default"} onClick={() => this.handleCancel()}>取消</Button>
            <div className="sumarea_list_8">
              <span className="sumarea_list_8_1" >最多选择</span>
              <span className="sumarea_list_8_2" >8</span>
              <span className="sumarea_list_8_3" >个汇总项</span>
            </div>
          </div>
          {AddFormula}
        </div>
      );
    }
  }
  dragOrder(evl) {
    let sumConfig = this.state.sumConfig
    let afterDragItems = [];
    evl.forEach(function (ele) {
      sumConfig.items.forEach(function (val, index) {
        if (index == ele) {
          afterDragItems.push(val)
        }
      })
    })
    sumConfig.items = afterDragItems
    this.setState({ sumConfig })
  }
  editFormula = (ele) => {
    this.handleCancel()
    this.setState({ editData: ele, newAdd: true })
  }
  deleteFormula = (fieldname) => {
    this.controlModal = true;
    cb.utils.confirm("确定删除此自定义公式么？", () => {
      this.controlModal = false;
      this.deleteRow(fieldname)
    }, () => {
      this.controlModal = false;
    })
  }
  deleteRow = (fieldname) => {
    let { sumConfig } = this.state;
    let items = sumConfig.items;
    let copyitems = [];
    items.forEach((ele) => {
      if (ele.fieldname != fieldname) {
        copyitems.push(ele)
      }
    })
    //  delete this.state.sumConfig.items;
    sumConfig.items = copyitems;
    // this.formulaLaft = [];
    this.setState({ sumConfig })
  }
  getEleText = (ele) => {
    let value = ele.value;
    let str = "无对应值";
    let arr = ele.enumArray && JSON.parse(ele.enumArray);
    // arr.push({ "nameType": "text", "value": "无无", "key": "" }, )
    let tmp = _.find(arr, function (o) { return o.key == ele.value });
    if (tmp)
      str = tmp.value;
    return str;
  }
  getDepends = (copyItems, dependsValue, data) => {
    let self = this;
    copyItems.forEach((ele) => {
      // let _index = _.findIndex(data, (obj) => {
      //   return obj.fieldname == ele && obj.depends
      // })
      let filterData = data.filter(v => (v.depends && v.fieldname == ele))
      if (filterData.length > 0) {
        let splitDepends = filterData[0].depends.split(',')
        dependsValue = dependsValue.concat(splitDepends)
        dependsValue.push(ele)
        self.getDepends(splitDepends, dependsValue, data)
      }
      // else{
      //   dependsValue.push(ele)
      // }
    })
    return dependsValue
  }
  handleOk = () => {
    let self = this;
    // let {dependsValue} = self.state;
    let sumConfig = self.state.sumConfig;
    let sumConfigItems = [], dependItems = [], dependsValue = [];
    // self.dependsValue = [];
    let params = {};
    sumConfig.items.forEach((ele, index) => {
      if (ele.depends && ele.selected) {
        let splitDepends = ele.depends.split(',')
        dependItems = dependItems.concat(splitDepends)
      }
    })
    dependItems = dependItems.filter(function (element, index, self) {
      return self.indexOf(element) === index;
    })
    if(dependItems.length > 0){
    dependsValue = self.getDepends(dependItems, dependsValue, sumConfig.items).concat(dependItems)
    dependsValue = dependsValue.filter(function (element, index, self) {
      return self.indexOf(element) === index;
    })
    sumConfig.items.forEach((ele) => {
      if (!ele.selected) {
        let _index = _.findIndex(dependsValue, (obj) => {
          return obj == ele.fieldname
        })
        if (_index > -1) {
          if (ele.columnDefine) {
            ele.columnDefine = typeof (ele.columnDefine) == 'string' ?JSON.parse(ele.columnDefine) : ele.columnDefine
          }
          else{ele.columnDefine = {}}
          Object.assign(ele.columnDefine,{ "bShowIt": "false" });
          ele.selected = 1;
          ele.columnDefine = JSON.stringify(ele.columnDefine);
          sumConfigItems.push(ele)
        }
      }
      else {
        if (ele.columnDefine && typeof (ele.columnDefine) != 'string') {
          ele.columnDefine = JSON.stringify(ele.columnDefine)
        }
        sumConfigItems.push(ele)
      }
    })
    sumConfig.items = sumConfigItems;
    }
    params.billnum = self.state.billnum;
    params.id = sumConfig.id;
    params.name = sumConfig.name;
    params.items = _.filter(sumConfig.items, function (o) { return o.selected == 1; });
    params.isOnlyTotal = true;
    let callback = (json) => {
      if (json.code === 200) {
        self.setState({ bShowList: false, showCardFieldName: "", bOnlyShowSelected: true, showPop: false });
        self.props.viewModel.execute('saveSumArea');
      }
      if (json.code !== 200) {
        console.log("保存汇总区设置失败。信息 : " + (json.message ? json.message : JSON.stringify(json)).toString());
        // self.setState({ bShowList: false });
      }
    }
    eChartProxy.doProxy(eChartProxy.url.saveTotalSchema, 'POST', params, callback);

  }
  handleCancel = () => {
    this.setState({ bShowList: false, showCardFieldName: "", bOnlyShowSelected: true, showPop: false });
  }
  handleAdd = () => {
    let addLength = 0;
    let { sumConfig } = this.state
    addLength = _.filter(sumConfig.items, function (element) {
      if (element.columnDefine) {
        let columnDefine = typeof (element.columnDefine) == 'string' ? JSON.parse(element.columnDefine) : element.columnDefine
        return columnDefine.bShowIt == "false" && element.selected == 1
      }
    }).length
    if (!sumConfig.items.length) {
      cb.utils.alert("选择公式所需条件后才可新增公式")
    }
    let copysum = sumConfig.items.filter(v => v.selected == 1)
    if (copysum.length >= (8 + addLength)) {
      cb.utils.alert("当前已经有8个汇总项，不可再增加公式")
      // cb.utils.alert("公式所需条件数量不可大于7")
    }
    else {
      this.setState({ bShowList: false, showCardFieldName: "", bOnlyShowSelected: true, newAdd: true, editData: {}, showPop: false });
    }
  }
  closeAdd = () => {
    this.setState({ newAdd: false })
  }
  getConfig() {
    let self = this;
    let param = { billnum: self.state.billnum, isOnlyTotal: true };
    let callback = (json) => {
      if (json.code === 200) {
        // this.formulaLaft = [];
        if (json.data) {
          eChartCommon.LogChartInfo("设置汇总区  eChartConfig", json.data.chartConfig, 7);
          self.setState({ sumConfig: json.data });
          return;
        }
      }
      eChartCommon.LogChartInfo("设置汇总区_配置信息读取失败或者交叉表不支持 查询参数 =" + JSON.stringify(param) + "  json.message", json.message, 999);
    }
    eChartProxy.doProxy(eChartProxy.url.getTotalSetting, 'GET', param, callback);

  }

}





// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/sumareasetting.jsx